<template>
  <div class="merchandiserView" :key="`merchandiserView_` + $store.state.calculatorData.merchandiserViewToggleState">
    <h2>{{ $t(`merchandiserView.title`)}}</h2>
    <p v-html="$t(`merchandiserView.infoText`)"></p>
    <div class="merchandiserView-content-holder 2-columns">
      <div class="mv-stepholder">
         <span class="mv-step-title">1 - {{ $t(`insulationMaterial.title`)}}</span>
        <div class="radio-tile-group columns-3">
          <StoRadio step="insulationMaterial" type="eps" />
          <StoRadio step="insulationMaterial" type="epsAndPlaster"/>
          <StoRadio step="insulationMaterial" type="foamglas" />
        </div>

        <div v-if="isBox && elementForm !== 'jaka'" class="slider-wrapper input-container highlight-box calculated-box">
          <div class="row space-between">
            <div class="col-md-8">
                <span v-html="$t(`variablesNice.w`)"></span>
                <p>W = B - E - H</p>
            </div>
            <div class="col-12 d-md-none text-align-right spacebottom-to-sm">
              <input type="number" :min="min" :max="max" :value="w" class="slider-input disabled" disabled="disabled"> mm
            </div>
            <div class="col-md-4 d-none d-md-block">
              <input type="number" :min="min" :max="max" :value="w" class="slider-input disabled" disabled="disabled"> mm
            </div>

            <div v-if="$store.state.calculatorData.errors['w'] === 'min'" class="col-12 error">
              {{$tc(`elementWidths.werrorMin`, min, {min: calculatorMin.w()})}}
            </div>
            <div v-if="$store.state.calculatorData.errors['w'] === 'max'" class="col-12 error">
              {{$tc(`elementWidths.werrorMax`, max, {max: calculatorMax.w()})}}
            </div>
          </div>
        </div>

      </div>
      <div class="mv-stepholder">
        <span class="mv-step-title">2 - {{ $t(`elementForm.title`)}}</span>
        <div class="radio-tile-group columns-2" v-if="$store.state.calculatorData.currentOrder.insulationMaterial === 'eps'">
          <StoRadio step="elementForm" type="jak" />
          <StoRadio step="elementForm" type="jas" />
        </div>
        <div class="radio-tile-group columns-2"  v-else-if="$store.state.calculatorData.currentOrder.insulationMaterial === 'foamglas'">
          <StoRadio step="elementForm" type="jaka" />
          <StoRadio step="elementForm" type="jasa" />
        </div>
        <div class="radio-tile-group columns-2" v-else-if="$store.state.calculatorData.currentOrder.insulationMaterial === 'epsAndPlaster'">
          <StoRadio step="elementForm" type="jakp" />
          <StoRadio step="elementForm" type="jasp" />
        </div>

        <div class="slider-wrapper input-container highlight-box calculated-box">
          <div class="row space-between">
            <div class="col-md-8">
                <span v-html="$t(`variablesNice.h`)"></span>
            </div>
            <div class="col-12 d-md-none text-align-right spacebottom-to-sm">
              <input type="number" :min="min" :max="max" :value="h" class="slider-input disabled" disabled="disabled"> mm
            </div>
            <div class="col-md-4 d-none d-md-block">
              <input type="number" :min="min" :max="max" :value="h" class="slider-input disabled" disabled="disabled"> mm
            </div>
          </div>
        </div>

      </div>
      <div class="mv-stepholder" v-if="elementForm !== ''" :key="`mw_elementLengths`+ $store.state.calculatorData.merchandiserViewToggleState">
        <span class="mv-step-title">3 - {{ $t(`elementLengths.title`)}}</span>
        <StoSlider name="a" tab="merchandiserView" />
        <StoSlider name="a1" tab="merchandiserView" />
        <StoSlider name="a2" tab="merchandiserView" />
        <br />
        <div>

          <div class="slider-wrapper input-container highlight-box calculated-box">
            <div class="row space-between">
              <div class="col-md-8">
                  <span v-html="$t(`elementLengths.fullLength`)"></span>
              </div>
              <div class="col-12 d-md-none text-align-right spacebottom-to-sm">
                <input type="number" :min="min" :max="max" :value="totalLength" class="slider-input disabled" disabled="disabled"> mm
              </div>
              <div class="col-md-4 d-none d-md-block">
                <input type="number" :min="min" :max="max" :value="totalLength" class="slider-input disabled" disabled="disabled"> mm
              </div>
            </div>
          </div>

          <p>{{ $t(`variablesNice.totalElements`)}}: {{ totalElements }} </p>
        </div>
      </div>
      <div class="mv-stepholder" v-if="elementForm !== ''">
        <span class="mv-step-title">4 - {{ $t(`elementHeights.title`)}}</span>
        <div>
          <StoSlider name="c" tab="merchandiserView" />
          <StoSlider name="d1" tab="merchandiserView" />
        </div>

        <div class="slider-wrapper input-container highlight-box calculated-box">
          <div class="row space-between">
            <div class="col-md-8">
                <span v-html="$t(`variablesNice.d2`)"></span>
                <p>D2 = C - D</p>
            </div>
            <div class="col-12 d-md-none text-align-right spacebottom-to-sm">
              <input type="number" :min="min" :max="max" :value="d2" class="slider-input disabled" disabled="disabled"> mm
            </div>
            <div class="col-md-4 d-none d-md-block">
              <input type="number" :min="min" :max="max" :value="d2" class="slider-input disabled" disabled="disabled"> mm
            </div>

            <div v-if="$store.state.calculatorData.errors['d2'] === 'min'" class="col-12 error">
              {{$tc(`elementHeights.d2errorMin`, min, {min: calculatorMin.d2()})}}
            </div>
            <div v-if="$store.state.calculatorData.errors['d2'] === 'max'" class="col-12 error">
              {{$tc(`elementHeights.d2errorMax`, max, {max: calculatorMax.d2()})}}
            </div>
            <div v-if="$store.state.calculatorData.errors['d2'] === 'steps'" class="col-12 error">
              {{ $t('elementHeights.errorStep10') }}
            </div>
          </div>
        </div>

      </div>
      <div class="mv-stepholder" v-if="elementForm !== ''">
        <span class="mv-step-title">5 - {{ $t(`elementWidths.title`)}}</span>
        <StoSlider name="e" tab="merchandiserView" />
        <StoSlider name="b" tab="merchandiserView" />
        <br />

        <div class="slider-wrapper input-container highlight-box calculated-box">
          <div class="row space-between">
            <div class="col-md-8">
                <span v-html="$t(`variablesNice.h`)"></span>
            </div>
            <div class="col-12 d-md-none text-align-right spacebottom-to-sm">
              <input type="number" :min="min" :max="max" :value="h" class="slider-input disabled" disabled="disabled"> mm
            </div>
            <div class="col-md-4 d-none d-md-block">
              <input type="number" :min="min" :max="max" :value="h" class="slider-input disabled" disabled="disabled"> mm
            </div>
          </div>
        </div>

        <div v-if="isBox && elementForm !== 'jaka'" class="slider-wrapper input-container highlight-box calculated-box">
          <div class="row space-between">
            <div class="col-md-8">
                <span v-html="$t(`variablesNice.w`)"></span>
                <p>W = B - E - H</p>
            </div>
            <div class="col-12 d-md-none text-align-right spacebottom-to-sm">
              <input type="number" :min="min" :max="max" :value="w" class="slider-input disabled" disabled="disabled"> mm
            </div>
            <div class="col-md-4 d-none d-md-block">
              <input type="number" :min="min" :max="max" :value="w" class="slider-input disabled" disabled="disabled"> mm
            </div>

            <div v-if="$store.state.calculatorData.errors['w'] === 'min'" class="col-12 error">
              {{$tc(`elementWidths.werrorMin`, min, {min: calculatorMin.w()})}}
            </div>
            <div v-if="$store.state.calculatorData.errors['w'] === 'max'" class="col-12 error">
              {{$tc(`elementWidths.werrorMax`, max, {max: calculatorMax.w()})}}
            </div>
          </div>
        </div>

      </div>
      <div class="mv-stepholder" v-if="elementForm !== ''">
        <span class="mv-step-title">6 - {{ $t(`vacuumPanels.title`)}}</span>
        <div v-if="elementForm === 'jak' || elementForm === 'jakp'" class="radio-tile-group columns-2">
          <StoRadio step="vacuumPanels" type="vip" />
          <StoRadio step="vacuumPanels" type="novip" />
        </div>
        <div v-else class="radio-tile-group columns-2">
          <StoRadio step="vacuumPanels" type="vip" :disabled="true" />
          <StoRadio step="vacuumPanels" type="novip" />
        </div>
        <div v-if="isBox && elementForm !== 'jaka'" class="slider-wrapper input-container highlight-box calculated-box">
          <div class="row space-between">
            <div class="col-md-8">
                <span v-html="$t(`variablesNice.w`)"></span>
                <p>W = B - E - H</p>
            </div>
            <div class="col-12 d-md-none text-align-right spacebottom-to-sm">
              <input type="number" :min="min" :max="max" :value="w" class="slider-input disabled" disabled="disabled"> mm
            </div>
            <div class="col-md-4 d-none d-md-block">
              <input type="number" :min="min" :max="max" :value="w" class="slider-input disabled" disabled="disabled"> mm
            </div>

            <div v-if="$store.state.calculatorData.errors['w'] === 'min'" class="col-12 error">
              {{$tc(`elementWidths.werrorMin`, min, {min: calculatorMin.w()})}}
            </div>
            <div v-if="$store.state.calculatorData.errors['w'] === 'max'" class="col-12 error">
              {{$tc(`elementWidths.werrorMax`, max, {max: calculatorMax.w()})}}
            </div>
          </div>
        </div>
      </div>
      <div class="mv-stepholder" v-if="elementForm !== ''">
        <span class="mv-step-title">7 - {{ $t(`notches.title`)}}</span>
        <div v-if="isBox">
          <div class="radio-tile-group columns-2">
            <StoRadio step="notches" type="notch" />
            <StoRadio step="notches" type="noNotch" />
          </div>
          <div v-if="notches === 'notch'">
            <StoSlider name="g" tab="merchandiserView" />
            <StoSlider name="f" tab="merchandiserView" />
          </div>
        </div>
        <div v-else>
          <div class="radio-tile-group columns-2">
            <StoRadio step="notches" type="notch" :disabled="true" />
            <StoRadio step="notches" type="noNotch" />
          </div>
        </div>
      </div>
      <div class="mv-stepholder" v-if="elementForm !== ''">
        <span class="mv-step-title">8 - {{ $t(`endProfiles.title`)}}</span>
        <div v-if="elementForm !== 'jaka'">
          <span class="mv-step-title">{{ $t(`wallProfiles.title`)}}:</span>
          <div class="radio-tile-group columns-3">
            <StoRadio step="wallProfiles" type="uf" :disabled="wallProfilDisabled('uf') || elementForm === 'jaka'" />
            <StoRadio step="wallProfiles" type="t" :disabled="wallProfilDisabled('t') || elementForm === 'jaka'" />
          </div>
        </div>
        <div v-if="elementForm !== 'jaka'" class="stripColor">
          <h3>{{ $t(`endProfiles.stripColor.title`)}}</h3>
          <div v-if="(elementForm === 'jakp') || (elementForm === 'jasp') || (elementForm === 'jasa')">
            <div class="info-wrapper">
              <p class="info" v-html="$t('endProfiles.stripColor.triggerInfo1')"></p>
            </div>
          </div>
          <div v-else>
          <label class="radio-label" :class="{ 'disabled': elementForm === 'jaka' }">
            {{ $t(`endProfiles.stripColor.options.alu`)}}
            <input type="radio" :class="`${checkedProfilColorAlu()}`" name="stripColor" value="alu" v-on:change="updateInputProfilColor" :disabled="elementForm === 'jaka'">
            <span class="checkmark"></span>
          </label>
          <label class="radio-label" :class="{ 'disabled': elementForm === 'jaka' }">
            {{ $t(`endProfiles.stripColor.options.white`)}}
            <input type="radio" :class="`${checkedProfilColorWhite()}`" name="stripColor" value="white" v-on:change="updateInputProfilColor" :disabled="elementForm === 'jaka'">
            <span class="checkmark"></span>
          </label>
          <label class="radio-label ral-wrapper-label row" :key="$store.state.calculatorData.currentOrder.profilColor" :class="{ 'disabled': elementForm === 'jaka' }">
            <div class="col-md-4 col-flex">
              <div class="ral-wrapper-label-content">
                <span v-html="$t(`endProfiles.stripColor.options.special`)"></span>
                <input type="radio" :class="`${checkedProfilColorRal()}`" name="stripColor" value="ral" v-on:change="updateInputProfilColor" :disabled="elementForm === 'jaka'">
                <span class="checkmark"></span>
              </div>
            </div>
            <div class="col-md-8">
              <RALSelection v-if="elementForm !== 'jaka'" />
            </div>
          </label>
        </div>
        </div>
        <span class="mv-step-title">{{ $t(`dripEdgeProfile.title`)}}:</span>
        <div class="radio-tile-group columns-3">
          <StoRadio step="dripEdgeProfile" type="3" :disabled="dripEdgeProfileState()"/>
          <StoRadio step="dripEdgeProfile" type="6" :disabled="dripEdgeProfileState()"/>
          <StoRadio step="dripEdgeProfile" type="10" :disabled="dripEdgeProfileState()"/>
        </div>
      </div>
      <!-- <div class="mv-stepholder">
        <span class="mv-step-title">9 - {{ $t(`mountingBracket.title`)}}</span>
        <label>{{ $t(`mountingBracket.orderPreText`)}} <input class="mountingBracket-input" type="number" :min="2" /> {{ $t(`mountingBracket.orderSuffixText`)}}</label>
      </div> -->
      <div class="mv-stepholder cta-wrapper">
        <div>
          <p v-if="this.$store.state.calculatorData.tinyLink">
            <!-- <button @click="shortenerLink()"> {{ tinyLink }} link</button> -->
            <a :href="shortenerLink()"> {{ shortenerLink() }} </a>
          </p>
          <button v-else @click="createTinyLink">{{ $t(`merchandiserView.generateLink`)}}</button>
        </div>
        <div>
          <button @click="downloadPDF()"> {{ $t(`finalSummary.downloadButton`)}}</button>
          <p v-if="pdfStatus === 'serverRequestStart'">
            {{ $t(`pdf.pdfStatus.serverRequestStart`)}}
          </p>
          <p v-else-if="pdfStatus === 'serverError'">
            {{ $t(`pdf.pdfStatus.serverError`)}}
          </p>
          <p v-else-if="pdfStatus === 'serverPDFCreatingError'">
            {{ $t(`pdf.pdfStatus.serverPDFCreatingError`)}}
          </p>
          <p v-else-if="pdfStatus === 'serverAutoDownload'">
            {{ $t(`pdf.pdfStatus.serverAutoDownload`)}}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StoSlider from './StoSlider.vue'
import StoRadio from './StoRadio.vue'
import RALSelection from './RALSelection.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'MerchandiserView',
  components: {
    StoSlider,
    StoRadio,
    RALSelection
  },
  data () {
    return {
      tinyStatus: null,
      min: Number,
      max: Number,
      pdfStatus: ''
    }
  },
  computed: {
    ...mapGetters([
      'insulationMaterial',
      'elementForm',
      'a',
      'a1',
      'a2',
      'c',
      'd1',
      'd2',
      'e',
      'b',
      'vacuumPanels',
      'g',
      'f',
      'wallProfiles',
      'profilColor',
      'dripEdgeProfile',
      'notches',
      'isBox',
      'w',
      'h',
      'totalLength',
      'totalElements',
      'tinyLink',
      'base64Link',
      'calculatorMax',
      'calculatorMin'
    ])
  },
  methods: {
    createTinyLink: function (event) {
      // this line needs to track only User Input
      this.$root.$children['0'].userDidAction = true

      let postData = { original_string: this.base64Link }
      this.axios.post(
        process.env.VUE_APP_LOCAL_API_URL + '/shorten',
        postData
      ).then(r => {
        if (r.status === 200) {
          this.$store.commit('updateTinyLink', r.data.answer)
          this.tinyStatus = 'OK'
          this.tracking('TinyLink erstellt')
        } else if (r.status === 400) {
          this.tinyStatus = 'ERORR'
          this.tracking('Fehler beim Erstellen des Tinylinks')
        }
      }).catch(error => {
        console.log(error.response)
        this.tracking('ServerError')
      })
    },
    wallProfilDisabled: function (profilTyp) {
      // false = Element is enabled and clickable
      // true = Element is disabled. Not clickable

      if (!this.isBox) {
        return true
      }
      /*
        conditions for Profiles
        w (ab 20 <30) => only UF Profile
        w (30 <= => 60) UF and T Profile
        w (>60 ) only T
      */
      /*
        conditions for Profiles
        20, 30, 40, 50 und 60 mm
      */

      const availableProfilWidths = [ 20, 30, 40, 50, 60 ]

      if (availableProfilWidths.includes(this.$store.state.calculatorData.currentOrder.w) && (profilTyp === 'uf')) {
        return false
      }

      if ((this.$store.state.calculatorData.currentOrder.w > 30) && (profilTyp === 't')) {
        return false
      }

      return true
    },
    shortenerLink: function () {
      return process.env.VUE_APP_LOCAL_API_URL.replace(/^\/\//, `${location.protocol}//`) + '/shortener/' + this.tinyLink
    },
    downloadPDF: function (event) {
      // this line needs to track only User Input
      this.$root.$children['0'].userDidAction = true

      const fileName = this.$t(`pdf.pdfFileNamePrefix`) + this.$store.state.calculatorData.currentOrder.elementForm + '.pdf'
      let myOrder = Object.assign({}, this.$store.state.calculatorData.currentOrder)
      myOrder.elementForm = this.$t(`elementForm.${myOrder.elementForm}.pdfTitle`)
      myOrder.wallProfiles = this.$t(`wallProfiles.${myOrder.wallProfiles}.niceShort`)
      myOrder.vacuumPanels = (myOrder.vacuumPanels === 'vip')
      myOrder.dripEdgeProfile = parseInt(myOrder.dripEdgeProfile)
      myOrder.imgPathforPDF = '/img/pdfimages/' + this.$store.state.calculatorData.currentOrder.elementForm + '.jpg'
      this.pdfStatus = 'serverAutoDownload'
      this.axios({
        method: 'post',
        url: process.env.VUE_APP_LOCAL_API_URL + '/pdf',
        data: {
          pdf_info: myOrder
        },
        responseType: 'blob'
      }).then(r => {
        if (r.status === 200) {
          const url = window.URL.createObjectURL(new Blob([r.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          this.tracking('Bestellformular (PDF) runterladen')
        } else if (r.status === 400) {
          this.store = 'serverPDFCreatingError'
          this.tracking('Error Creating PDF')
        }
      }).catch(error => {
        this.pdfStatus = 'serverError'
        console.log(error.response)
        this.tracking(this.pdfStatus)
      })
    },
    dripEdgeProfileState: function () {
      if (this.elementForm === 'jas' || this.elementForm === 'jak') {
        return true
      }
      return false
    },
    checkedProfilColorAlu: function () {
      let isChecked = ''
      if (this.$store.state.calculatorData.currentOrder.profilColor === 'alu') {
        isChecked = 'checked'
      }
      return isChecked
    },
    checkedProfilColorWhite: function () {
      let isChecked = ''
      if (this.$store.state.calculatorData.currentOrder.profilColor === 'white') {
        isChecked = 'checked'
      }
      return isChecked
    },
    checkedProfilColorRal: function () {
      let isChecked = ''
      if ((this.$store.state.calculatorData.currentOrder.profilColor !== '') && (this.$store.state.calculatorData.currentOrder.profilColor !== 'white') && (this.$store.state.calculatorData.currentOrder.profilColor !== 'alu')) {
        isChecked = 'checked'
      }
      return isChecked
    },
    updateInputProfilColor: function (event) {
      const payload = {
        key: 'profilColor',
        value: event.target.value,
        validate: true
      }
      this.$store.dispatch('didInputFkt', payload)
    },
    tracking: function (status) {
      let gtmEvent = 'JKK-Events'
      let gtmEventCategory = 'Expertenansicht'
      let gtmEventAction = 'Button'
      let gtmEventLabel = status
      let virtualPageURL = '/expertenansicht'
      let virtualPageTitle = 'Expertenansicht'
      this.$root.$children['0'].globalGTMFkt(gtmEvent, gtmEventCategory, gtmEventAction, gtmEventLabel, '', virtualPageURL, virtualPageTitle)
    }
  },
  mounted: function () {
    // console.log('--- MerchandiserView rendert ---')
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
